import { get as _get } from "lodash";
import api from "../../helpers/api";

export const fetchCampaignDashboardData = (campaignId) => {
  return api().get(`/campaign/dashboard/${campaignId}`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching campaign dashboard data."),
      data: {},
    };
  });
};

export const fetchCampaignPowerBIToken = (powerBIType, variables) => {
  return api().options(`/campaign/powerbi/${powerBIType}`, { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching report details."),
      data: {},
    };
  });
};

export const getCampaignAssetList = (variables) => {
  return api().options("/campaign/assets", { data: (variables || {}) }).then((res) => {

    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Campaign content data fetched successfully."),
      data: _get(res, "data.responseData", {}),
    }
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching campaign content data."),
      data: {},
    };
  });
};

export const doGetCampaignList = (variables) => {
  return api().options("/campaign/campaign_list", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Campaign list fetched successfully."),
      data: _get(res, "data", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching campaign list."),
      data: {},
    };
  });
};

export const deleteCampaignAssets = (campaignId, data) => {
  return api().delete(`/campaign/delete_assets/${campaignId}`, { data }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Campaign Asset deleted successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while deleting campaign asset."),
      data: {}
    };
  });
}

export const doDeleteCampaign = (campaignIds) => {
  return api().delete("/campaign/bulk", { data: (campaignIds || []) }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Campaign deleted successfully."),
      data: _get(res, "data.responseData", {}),
    }
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while deleting campaign."),
      data: {},
    };
  });
};

export const doMarkAsCompleteCampaign = (variables) => {
  return api().patch("/campaign/mark_completed", variables).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Campaign marked as completed successfully."),
      data: _get(res, "data.responseData", {}),
    }
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while marking campaign as completed."),
      data: {},
    };
  });
};

export const exportAllCampaignAssets = (variables) => {
  return api().options("/campaign/list/export/all", { data: (variables) }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while exporting campaigns."),
      data: {},
    };
  });
};

export const exportSelectedCampaignAssets = (variables) => {
  return api().options(`/campaign/assets/export`, { data: variables }).then((res) => {

    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Assets exported successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while exporting asset(s)."),
      data: {}
    };
  });
}

export const downloadCampaignAssetsAsZip = (variables) => {
  return api().options(`/campaign/assets/downloads`, { data: variables }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Assets downloaded successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while downloading asset(s)."),
      data: {}
    };
  });
}

export const fetchCampaignDetails = (campaignId) => {
  return api().get(`/campaign/detail/${(campaignId || 0)}`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching campaign details."),
      data: {},
    };
  });
};

export const exportCampaignBriefs = (variables) => {
  return api().options(`/campaign/export/briefs`, { data: variables }).then((res) => {

    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Briefs exported successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while exporting Briefs."),
      data: {}
    };
  });
}

export const cloneSelectedBrief = (variables) => {

  return api().post(`/campaign/brief/${variables.brief_id}/clone`, {}).then((res) => {

    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while copying brief."),
      error: _get(err, "response.data.responseData.errors", {}),
    };
  });
}

export const exportUploadTemplateData = (variables) => {
  return api().options(`/campaign/export/lead_upload_template`, { data: variables }).then((res) => {

    return {
      flag: true,
      message: _get(res, "data.responseMessage", "File generated successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while exporting upload template."),
      data: {}
    };
  });
}

export const sendExportUploadTemplateMail = (variables) => {
  return api().options(`/campaign/export/lead_upload_template`, { data: variables }).then((res) => {

    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Email sent successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while sending email."),
      data: {}
    };
  });
}

export const createAssetsWithExisting = (variables) => {

  return api().post("/campaign/create_asset_with_existng", variables).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {

    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while storing uploaded data."),
      error: _get(err, "response.data.responseData.errors", {}),
      data: {}
    };
  });
}

export const fetchCampaignLeadDetails = (variables) => {
  return api().options("lead/campaign", { data: variables }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong fetching campaign leads."),
      data: {}
    };
  });
}

export const updateLeadStatus = (variables) => {
  return api().patch("/lead/approval_status", variables).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Lead status updated successfully."),
      data: _get(res, "data.responseData", {}),
    }
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while updating lead status."),
      data: {},
    };
  });
};

export const exportSelectedLeads = (variables) => {
  return api().options("/lead/export", { data: variables }).then((res) => {

    return {
      flag: true,
      message: _get(res, "data.responseMessage", "File exported successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while exporting lead(s)."),
      data: {}
    };
  });
}

export const getLeadExportPreview = (variables) => {
  return api().options("/lead/export_preview", { data: variables }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Data fetched successfully."),
      data: _get(res, "data.responseData", []),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching preview data."),
      data: []
    };
  });
};

export const fetchCampaignLeadFilter = (campaignId) => {
  return api().get(`lead/${(campaignId || 0)}/combined/details`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching filter values."),
      data: {},
    };
  });
};

export const fetchPipingLeadCounts = (variables) => {
  return api().options("/lead/lead_count_piping", { data: variables }).then((res) => {

    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Leads count fetched successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching leads count."),
      data: {}
    };
  });
}

export const exportPreviewLeads = (variables) => {
  return api().options("/campaign/lead_pipe_preview", { data: variables }).then((res) => {

    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Preview leads fetched successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while exporting preview leads."),
      data: {}
    };
  });
}

export const exportPipingReport = (variables) => {
  return api().options("/campaign/lead_pipe_export", { data: variables }).then((res) => {

    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Piping report fetched successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while piping report.."),
      data: {}
    };
  });
}

export const submitLeadsToCRM = (variables) => {

  return api().post("lead/initiate_piping", variables).then((res) => {

    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Leads successfully piped to partner's CRM."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while pushing leads to CRM."),
      data: {}
    };
  });
}

export const getLeadColumnList = () => {
  return api().get("lookup/lead_column_filter").then((res) => {

    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Lead columns fetched successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching lead columns."),
      data: {}
    };
  });
}

export const getLeadColumnMasterList = (masterId) => {
  return api().get(`lookup/lead/master/${masterId}/data`).then((res) => {

    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Column master list fetched successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching column master list."),
      data: {}
    };
  });
}

export const updateLeadColumnValue = (leadId, variables) => {
  return api().put(`/lead/${leadId}`, variables).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Lead updated successfully."),
      data: _get(res, "data", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while updating lead details."),
      data: {},
    };
  });
}

export const deleteSelectedLeads = (variables) => {
  return api().delete("/lead/delete", { data: variables }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Lead deleted successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while deleting lead."),
      data: {}
    };
  });
}

export const getCampaignDataHistory = (variables) => {
  return api().options("/lead/upload/details", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Campaign dataHistory fetched successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching campaign data history."),
      data: {},
    };
  });
}

export const downloadLeadsFile = (url, resultAsBlob) => {
  return api().post(`/download/file?file_url=${url}&result_as_blob=${resultAsBlob}`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Leads file downloaded successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {

    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while downloading leads file."),
      data: {}
    };
  });
}

export const fetchJobFunctionData = (variables) => {
  return api().options("/campaign/job_functions", { data: (variables || {}) }).then((res) => {

    return {
      flag: true,
      message: _get(res, "data.responseMessage", "job functions data fetched successfully."),
      data: _get(res, "data.responseData", {}),
    }
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching job functions data."),
      data: {},
    };
  });
};

export const getClientAnalysisList = (variables) => {
  return api().options("/campaign/client_analysis_lead", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Client Analysis data fetched successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching client analysis data."),
      data: {},
    };
  });
}

export const doGetCampaignListByClient = (variables) => {
  return api().options("/campaign/campaign_list_by_client", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Campaign list fetched successfully."),
      data: _get(res, "data", {}),
    }
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "data.responseMessage", "Something went wrong while fetching campaign list."),
      data: {},
    };
  });
};

export const doGetClientExportTemplate = (variables) => {
  return api().options("/campaign/client_export_template", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Export template list fetched successfully."),
      data: _get(res, "data", {}),
    }
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "data.responseMessage", "Something went wrong while fetching export template list."),
      data: {},
    };
  });
};

export const exportClientAnalysisData = (variables) => {
  return api().options("/campaign/export_client_lead", { data: variables }).then((res) => {

    return {
      flag: true,
      message: _get(res, "data.responseMessage", "File exported successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while exporting data."),
      data: {}
    };
  });
}

export const getClientExportTemplateList = (variables) => {
  return api().options("client/export_template_list", { data: variables }).then((res) => {

    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Export template list fetched successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching export template list."),
      data: {}
    };
  });
}

export const doGetDeepResearchReport = (campaignId) => {
  return api().get(`/campaign/deep_research/${(campaignId || 0)}`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Analysis report fetched successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching analysis report."),
      data: {},
    };
  });
};

export const getCompanyCardDetail = (variables) => {
  return api().options("/campaign/company_card_detail", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Company card detail fetched successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching company card detail."),
      data: {},
    };
  });
};

export const fetchNews = (variables) => {
  return api().options("/lead/company_news", { data: variables }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "News fetched successfully."),
      data: _get(res, "data.responseData", []),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching news."),
      data: [],
    };
  });
};

export const addAdhocContact = (variables) => {
  return api().post("/lead/adhoc_contact_card", variables).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Contact added successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while adding contact."),
      data: {},
    };
  });
};

export const doGenerateCompanyCardDeepResearch = (companyId) => {
  return api().post(`/Lead/company_card_deep_research/${(companyId || 0)}`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Deep research generation initiated successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while generating deep research."),
      data: {},
    };
  });
};

export const doDownloadCompanyCardDeepResearch = (companyId) => {
  return api().get(`/Lead/company_card_deep_research/${(companyId || 0)}/download?result_as_blob=false`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Deep research report downloaded successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while downloading deep research report."),
      data: {},
    };
  });
};

export const initiateCampaignDeepResearchPdf = (campaignId) => {
  return api().get(`/campaign/deep_research/${(campaignId || 0)}/pdf`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while initiating PDF generation."),
      data: {},
    };
  });
};

export const getCampaignDeepResearchPdfStatus = (requestId) => {
  return api().get(`/campaign/deep_research/pdf/status/${(requestId || "")}`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while checking PDF status."),
      data: {},
    };
  });
};

export const downloadCampaignDeepResearchPdf = (campaignId, requestId) => {
  const params = requestId ? `?request_id=${requestId}&result_as_blob=false` : `?result_as_blob=false`;
  return api().get(`/campaign/deep_research/${(campaignId || 0)}/pdf/download${params}`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "PDF report downloaded successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while downloading the PDF report."),
      data: {},
    };
  });
};

export const saveDeepResearchHtmlContent = (campaignId, htmlContent) => {
  return api().patch(`/campaign/deep_research/${(campaignId || 0)}`, { html_content: (htmlContent || "") }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Report saved successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while saving the report."),
      data: {},
    };
  });
};
